/*
Copyright (c) 2012-2025 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/

import { createContext, SetStateAction, Dispatch } from "react"
import { ACTION_TYPE } from "types/delv-platform-api/inventoryCategory"

export enum DRAWER_STATES {
  START,
  DOWNLOAD_CATALOGUE,
  PUBLISHABLE,
  PUBLISHING,
  PUBLISHING_ERROR_CHECK,
}

export enum BULK_UPLOAD_TYPE {
  INVENTORY = "inventory",
  MENU = "menu",
}

export type BulkUploadContextType = {
  bulkUploadType: BULK_UPLOAD_TYPE
  actionType: ACTION_TYPE
  drawerState: DRAWER_STATES
  drawerVisible: boolean
  drawerStateTransitionDisabled: boolean // currently, this state is consumed only by download catalogue drawer, prevent to change drawer state
  setActionType: Dispatch<SetStateAction<ACTION_TYPE>>
  setDrawerState: Dispatch<SetStateAction<DRAWER_STATES>>
  setDrawerVisible: Dispatch<SetStateAction<boolean>>
  setDrawerStateTransitionDisabled: Dispatch<SetStateAction<boolean>>
  modalEditorVisible: boolean
  setModalEditorVisible: Dispatch<SetStateAction<boolean>>
}

// use context to store drawer state because need to use setDrawerState at many places, some child components is too deep, and just passing prop would cause annoying
export const BulkUploadContext = createContext<BulkUploadContextType>({
  bulkUploadType: BULK_UPLOAD_TYPE.INVENTORY,
  actionType: ACTION_TYPE.UPDATE,
  drawerState: DRAWER_STATES.START,
  drawerVisible: false,
  drawerStateTransitionDisabled: false,
  setActionType: () => {},
  setDrawerState: () => {},
  setDrawerVisible: () => {},
  setDrawerStateTransitionDisabled: () => {},
  modalEditorVisible: false,
  setModalEditorVisible: () => {},
})
